import React from "react";
import get from "lodash/get";
import Icon from "assets/icons";
import { useFormikContext } from "formik";
import { InputType } from "shared/form/enum";
import Button from "shared/components/button";
import Direction from "shared/enums/Direction";
import { UserProfileService } from "../../types";
import { useCopies } from "shared/hooks/useCopies";
import FormTextField from "shared/form/fields/textField";
import { ChangePasswordFieldNameEnum } from "../../enums";
import useOnOutSideClick from "shared/hooks/useOnOutSideClick";
import FormCheckboxField from "shared/form/fields/checkboxField";
import { PasswordRequirementTooltip } from "apps/console/modules/resetPassword";

export default function ChangePassword(props: { service: UserProfileService }) {
  const copies = useCopies();
  const [focused, setFocused] = React.useState(false);
  const passwordFieldRef = React.useRef<HTMLDivElement>(null);
  useOnOutSideClick({
    node: passwordFieldRef.current,
    onOutSideClick: () => {
      setFocused(false);
    }
  });

  const { values } = useFormikContext<any>();
  return (
    <React.Fragment>
      <FormCheckboxField label={copies.get("change.password")} name={ChangePasswordFieldNameEnum.CHANGE_PASSWORD} />
      {values?.changePassword && (
        <React.Fragment>
          <FormTextField
            className="form_item--fullWidth"
            name={`${ChangePasswordFieldNameEnum.PASSWORD_FIELD_PREFIX}.${ChangePasswordFieldNameEnum.CURRENT_PASSWORD}`}
            label={copies.get("current.password")}
            type={InputType.PASSWORD}
            required
          />
          <div className="myProfileResetPassword" ref={passwordFieldRef}>
            <FormTextField
              className="form_item--fullWidth"
              name={`${ChangePasswordFieldNameEnum.PASSWORD_FIELD_PREFIX}.${ChangePasswordFieldNameEnum.NEW_PASSWORD}`}
              switchIconPosition={true}
              label={copies.get("new.password")}
              type={props.service.displayPassword ? InputType.TEXT : InputType.PASSWORD}
              required
              onFocus={() => {
                setFocused(true);
              }}
              icon={
                <Button
                  icon={props.service.displayPassword ? <Icon.VisibilityOff /> : <Icon.VisibilityOn />}
                  onClick={() => props.service.setDisplayPassword(!props.service.displayPassword)}
                  title={props.service.displayPassword ? copies.get("hide") : copies.get("show")}
                />
              }
            />
            <PasswordRequirementTooltip
              password={get(
                values,
                `${ChangePasswordFieldNameEnum.PASSWORD_FIELD_PREFIX}.${ChangePasswordFieldNameEnum.NEW_PASSWORD}`
              )}
              isPasswordTooltipOpen={focused}
              requirementTooltipDirection={Direction.TOP}
            />
          </div>
          <FormTextField
            className="form_item--fullWidth"
            name={`${ChangePasswordFieldNameEnum.PASSWORD_FIELD_PREFIX}.${ChangePasswordFieldNameEnum.CONFIRM_PASSWORD}`}
            label={copies.get("confirm.password")}
            type={InputType.PASSWORD}
            required
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
